import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Grid } from '@material-ui/core';
import React from 'react';
import styles from 'views/routes/unauthorised/Unauthorised.module.scss';

export const Unauthorised: React.FC = function () {
  return (
    <div className={styles.container}>
      <Grid
        container
        className={styles.container}
        direction="column"
        justify="center"
        alignItems="center"
        spacing={4}>
        <Grid item>
          <FontAwesomeIcon className={styles.iconColor} icon={faExclamationCircle} size={'10x'} />
        </Grid>
        <Grid className={styles.bold} item>
          Unauthorised
        </Grid>
        <Grid item>You do not have permission to view the page that you were looking for.</Grid>
      </Grid>
    </div>
  );
};
